import { jsxs as m, jsx as e } from "react/jsx-runtime";
import { memo as $, useMemo as g, useCallback as D } from "react";
import { u as x } from "../../styled-components.browser.esm-BFmoFexH.js";
import { Col as h, Checkbox as a, InputNumber as L } from "antd";
import { isEmpty as R } from "@biron-data/react-components";
import { RowWithDefaultValue as j } from "../utils.js";
import { useLanguageResolver as w } from "@biron-data/react-contexts";
const N = $(function({
  value: i,
  onSortChange: o,
  mandatory: S,
  affect: k,
  displaySlicerOtherOption: f,
  multiple: l
}) {
  const r = w(), [p, y] = r.get("configuration-chart-additional-detail.limitSeries.label").split("###"), d = g(() => (i == null ? void 0 : i.limitSeries) !== void 0, [i]), n = g(() => f && d, [f, d]), c = D((t, O) => {
    o == null || o({
      ...i,
      hideOthers: (i == null ? void 0 : i.hideOthers) ?? !n,
      isDefault: !1,
      [t]: O
    });
  }, [n, o, i]);
  return /* @__PURE__ */ m(z, { $isdefault: i != null && i.isDefault ? 1 : 0, $limitapplied: (i == null ? void 0 : i.limitSeries) === void 0 ? 0 : 1, children: [
    l && /* @__PURE__ */ e(h, { span: 3, children: r.get(`configuration-affect.${k}`) }),
    /* @__PURE__ */ m(h, { span: 21, children: [
      S ? p : /* @__PURE__ */ e(
        a,
        {
          checked: d,
          onChange: () => {
            c("limitSeries", R(i == null ? void 0 : i.limitSeries) ? 20 : void 0);
          },
          children: p
        }
      ),
      /* @__PURE__ */ e(L, { min: 1, value: i == null ? void 0 : i.limitSeries, style: { width: 70 }, size: "small", onChange: (t) => {
        t && c("limitSeries", t);
      } }),
      y,
      n && /* @__PURE__ */ e(b, { children: r.get("configuration-chart-additional-detail.limitSeries.shortDescription") })
    ] }),
    n && /* @__PURE__ */ m(h, { span: 21, offset: l ? 3 : 0, children: [
      /* @__PURE__ */ e(
        a,
        {
          checked: i == null ? void 0 : i.hideOthers,
          onChange: (t) => c("hideOthers", t.target.checked),
          children: r.get("configuration-chart-additional-detail.hideOthers.label")
        }
      ),
      /* @__PURE__ */ e(b, { children: r.get("configuration-chart-additional-detail.hideOthers.description") })
    ] })
  ] });
}), z = x(j)`
  margin-bottom: 6px;
  user-select: none;
    line-height: var(--line-height);


    &&& .ant-input-number {
        line-height: var(--line-height);
    }

    ${(s) => s.$isdefault && s.$limitapplied ? `
  .ant-checkbox-inner {
    border-color: var(--medium-grey) !important;
    background-color: var(--medium-grey) !important;
  }
  ` : ""}
`, b = x.span`
  margin-left: 10px;
  font-size: 12px;
  line-height: 16px;
  color: var(--medium-grey);
`;
export {
  N as default
};
//# sourceMappingURL=SingleLimitSelector.js.map
